import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { FooterProps } from "@components/molecules/GalleryView/utils/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { VDBIcons } from "@utils/VDBIcons";
import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { useTheme } from "styled-components/native";
import styled from "styled-components/native";

const Footer = ({
  currentIndex,
  total,
  centerString = "/",
  hasArrow,
  leftClickEvent,
  rightClickEvent,
  ceterIconTheme,
  preText = "",
  postText = "",
  enableArrowsOnEnd,
}: FooterProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();

  return (
    <View style={styles.container}>
      {hasArrow && (
        <TouchableOpacity onPress={() => leftClickEvent()}>
          <IconContainerLeft>
            <VDBIcon
              name={VDBIcons.ARROW_LEFT}
              size={24}
              color={
                enableArrowsOnEnd
                  ? ceterIconTheme
                  : currentIndex + 1 === 1
                  ? theme["core-04"]
                  : ceterIconTheme
              }
              variant={IconsVariant.VDBCustom}
            />
          </IconContainerLeft>
        </TouchableOpacity>
      )}
      {preText ? (
        <>
          <VDBText color={theme["core-06"]} type={typography["H3-R"]}>
            {preText}{" "}
          </VDBText>
          <VDBText color={theme["core-05"]} type={typography["H2-M"]}>
            {currentIndex + 1} {centerString} {total}{" "}
          </VDBText>
          <VDBText color={theme["core-06"]} type={typography["H3-R"]}>
            {postText}
          </VDBText>
        </>
      ) : (
        <VDBText color={theme["core-06"]} type={typography["Minor-M"]}>
          {currentIndex + 1} {centerString} {total}
        </VDBText>
      )}
      {hasArrow && (
        <TouchableOpacity onPress={() => rightClickEvent()}>
          <IconContainerRight>
            <VDBIcon
              name={VDBIcons.ARROW_RIGHT}
              size={24}
              color={
                enableArrowsOnEnd
                  ? ceterIconTheme
                  : currentIndex + 1 === total
                  ? theme["core-04"]
                  : ceterIconTheme
              }
              variant={IconsVariant.VDBCustom}
            />
          </IconContainerRight>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  text: {
    color: "white",
  },
});

const IconContainerLeft = styled.View`
  padding: 0 ${SpaceType.Basic}px;
`;

const IconContainerRight = styled.View`
  padding: 0 ${SpaceType.Basic}px;
`;

export default Footer;
